export default __webpack_public_path__ + "static/automation-reports-7aa22854229c9748cb6828a813f98781.png";